<template>
    <div id="app">
        <!--<ShotPane :scene="scene" />-->
        <TexturesPanel :scene="scene" />
        <div class="right-column">
            <Pane ref="pane" :scene="scene" />
            <SecondPanel :scene="scene" />
        </div>
        <Series :scene="scene" />
        <Intro :scene="scene" />
    </div>
</template>

<script>
    //import ShotPane from './components/ShotPane.vue';
    import Pane from './components/Pane.vue';
    import ControlPanel from './components/ControlPanel.vue';
    import TexturesPanel from './components/TexturesPanel.vue';
    import SecondPanel from './components/SecondPanel.vue';
    import Series from './components/Series.vue';
    import Intro from './components/Intro.vue';



    export default {
        name: 'app',
        data() {
            return {
                scene: this.getSceneFromRoute(),
            }
        },
        components: {
            //ShotPane,
            Pane,
            ControlPanel,
            TexturesPanel,
            SecondPanel,
            Series,
            Intro,
        },
        mounted() {
            //getSceneFromRoute()
            /* *
             *  Event przychodzi z Pane,
             *  kt�re wysy�a to zar�wno przy zmianie z klikni�cia w hotspot jak i po zmianie z buttonu,
             *  wi�c powinno to dzia�a� przy ka�dej zmianie sceny
             *  */
            this.$refs.pane.$on('scenechange', (val) => {
                this.scene = val
                this.$root.scene = val
                //this.$router.push(val)
            })
        },
        methods: {
            checkRoute: function () {
                return this.$root.currentRoute;
            },
            getSceneFromRoute: function () {
                let p = this.$root.currentRoute.split("/")[1];
                if (p === "") p = "intro";
                return p;
            },

        },
    }
</script>

<style>


    #app {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .row {
        position: relative;
        width: 100%;
        height: 600px;
    }

    .right-column {
        position: absolute;
        top: 0;
        right: 0;
        width: calc(100% - 340px);
        height: 100%;
        display: inline-block;
    }

    @media only screen and (max-device-width : 1024px) {
        .right-column {
            width: 100%;
        }
    }
</style>
